import { application } from './application'

import { definitions } from 'stimulus:.'
import { definitions as componentDefinitions } from 'stimulus:../../components'

application.load(definitions)
application.load(componentDefinitions)
